import {
	ILoginResponse,
	IRegisterResponse,
	ISLoginResponse,
	ISRegisterResponse,
} from '@/shared/services/auth/auth.types';

export function getStructuredLoginResponse(obj: ILoginResponse) {
	const structuredObj: ISLoginResponse = {
		jwtToken: obj.jwt_token,
		newUser: obj.new_user,
		email: obj.email,
	};

	return structuredObj;
}

export function getStructuredRegisterResponse(obj: IRegisterResponse) {
	const structuredObj: ISRegisterResponse = {
		jwtToken: obj.jwt_token,
		newUser: obj.new_user,
		email: obj.email,
	};

	return structuredObj;
}
